module.exports = __webpack_public_path__ + "static/2-0db247003c9a242690f64411da36c4a0.jpeg";